import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Gold extends Bloc {

	constructor (src, ctx) {

		super("gold", src, ctx);
		this.f = (src, ins) => [src.master.run.champion.gold];
		this.types = [];
	}
}